module.exports = __webpack_public_path__ + "img/dkzb_icon.a573d25f.png";